class MrShowCredits extends HTMLElement {
	#clickHandler = (): void => {
		const forEl = this.getForEl();
		if ( !forEl ) {
			return;
		}

		if ( forEl.hasAttribute( 'show-credits' ) ) {
			return;
		}

		const content: HTMLElement | null = forEl.querySelector( '.song-player-info__content' );
		const credits: HTMLElement | null = forEl.querySelector( '.song-player-info__credits' );

		if ( content && credits && matchMedia( '(min-width: 768px) and (max-width: 1023px)' ).matches ) {
			const creditsHeight = credits.clientHeight;
			if ( !creditsHeight ) {

				return;
			}

			content.style.transform = `translateY(-${creditsHeight + 40}px)`;
		}

		forEl.setAttribute( 'show-credits', '' );
	};

	connectedCallback() {
		this.addEventListener( 'click', this.#clickHandler );
	}

	disconnectedCallback() {
		this.removeEventListener( 'click', this.#clickHandler );
	}

	getForEl(): HTMLElement|null {
		const forElVideoId = this.getAttribute( 'for' );
		if ( !forElVideoId ) {
			return null;
		}

		return document.querySelector( `mr-video-player[video-id="${forElVideoId}"` );
	}
}

customElements.define( 'mr-show-credits', MrShowCredits );
